<template>

    <v-card >
        <v-card-title>{{$t('simulacion.modulo.precios.titulo')}}</v-card-title>
        <v-divider></v-divider>
        <v-card-text>
            <v-row>

              <v-col cols="12" class="d-flex justify-end mb-2">
                <v-btn color="primary" class="mx-2" @click="exportToCSV">
                  {{$t('comun.boton_exportar')}}
                </v-btn>
                
                <v-btn :disabled="this.disabled" color="primary" class="mx-2" @click="importFromCSV">
                  {{$t('comun.boton_importar')}}
                  <input
                    type="file"
                    accept=".csv"
                    ref="fileInput"
                    style="display: none;"
                    @change="handleCSVUpload"
                  />
                </v-btn>
              </v-col>


            <v-col cols="12">
                <v-container>
                  <v-row>      
                    <v-col cols=12>
                      <div id="app2">
                          <v-grid
                          :key="`precios-${datos_generales.anio_inicio}-${datos_generales.anio_fin}-${columns.length}`"
                          theme="material"
                          :source="datos"
                          :columns="columns"
                          canFocus=true
                          range=true
                          useClipboard=true
                          :readonly="this.disabled"
                          filter=true
                          resize=true
                          @afteredit="handleCellEdit"
                        ></v-grid>      
                      </div>
                    </v-col>      
                  </v-row>
                </v-container>

            </v-col>
            </v-row>
        </v-card-text>
    </v-card>


</template>

<script>
import VGrid from "@revolist/vue3-datagrid";
import Swal from 'sweetalert2';

//import ComponenteLoading from './ComponenteLoading.vue';
export default {

  props: {
  modelValue: {
    type: Array,
    required: true,
  },
  datos_generales: {
    type: Object,
    required: true,
  },
  disabled: {
    type: Boolean,
    default: false,
  }

  },

  data() {
    return {

      valid: false,
      datos: [],
      columns: [],          
      loading: false,
      

    };
  },

  components: {
    VGrid,    
  },

  watch: {
  modelValue: {
    immediate: true,
    deep: true,
    handler(newModelValue) {
      this.datos = this.normalizarDatosConHorizonte(newModelValue);
      this.setColumns();
    }
  },

  'datos_generales.anio_inicio'() {
    this.sincronizarDatosConHorizonte();
  },

  'datos_generales.anio_fin'() {
    this.sincronizarDatosConHorizonte();
  },

  '$i18n.locale'() {
    this.setColumns();
  },
},
methods: {
 esColumnaAnio(key) {
    return /^\d{4}$/.test(String(key));
  },

  listaAniosHorizonte() {
    const ini = Number(this.datos_generales?.anio_inicio);
    const fin = Number(this.datos_generales?.anio_fin);

    if (!ini || !fin || ini > fin) return [];

    return Array.from({ length: fin - ini + 1 }, (_, i) => String(ini + i));
  },

  obtenerUltimoAnioDisponible(row) {
    const anios = Object.keys(row)
      .filter(key => this.esColumnaAnio(key))
      .map(Number)
      .sort((a, b) => a - b);

    return anios.length ? String(anios[anios.length - 1]) : null;
  },

  normalizarDatosConHorizonte(filas) {
    const origen = Array.isArray(filas) ? filas : [];
    const aniosHorizonte = this.listaAniosHorizonte();

    return origen.map(row => {
      const nuevo = {};

      // Mantener columnas no anuales, por ejemplo periodo
      Object.keys(row).forEach(key => {
        if (!this.esColumnaAnio(key)) {
          nuevo[key] = row[key];
        }
      });

      const ultimoAnioDisponible = this.obtenerUltimoAnioDisponible(row);

      // Pintar exactamente los años del horizonte actual
      aniosHorizonte.forEach(anio => {
        if (row[anio] !== undefined) {
          nuevo[anio] = row[anio];
        } else if (ultimoAnioDisponible !== null) {
          // Solo se usa si ese año realmente no existe en el modelValue
          nuevo[anio] = row[ultimoAnioDisponible];
        } else {
          nuevo[anio] = 0;
        }
      });

      return nuevo;
    });
  },

  sincronizarDatosConHorizonte() {
    // OJO: aquí solo actualizamos la vista local.
    // No emitimos al padre, para no perder años ocultos.
    this.datos = this.normalizarDatosConHorizonte(this.modelValue);
    this.setColumns();
  },

  fusionarDatosEditadosConOriginal() {
    const originales = Array.isArray(this.modelValue) ? this.modelValue : [];

    if (!originales.length) {
      return this.datos.map(row => ({ ...row }));
    }

    const visiblesPorPeriodo = new Map(
      this.datos.map(row => [row.periodo, row])
    );

    return originales.map(filaOriginal => {
      const filaVisible = visiblesPorPeriodo.get(filaOriginal.periodo);

      if (!filaVisible) {
        return { ...filaOriginal };
      }

      return {
        ...filaOriginal, // conserva años ocultos, por ejemplo 2036-2060
        ...filaVisible,  // actualiza solo años visibles/editados
      };
    });
  },

  setColumns() {
    if (this.datos.length > 0) {
      const keys = Object.keys(this.datos[0]);

      this.columns = keys.map(key => ({
        name: key,
        prop: key,
        size: 120,
        readonly: false,
        cellTemplate: (h, props) => {
          const value = props.model[props.prop];

          return h(
            "span",
            {},
            typeof value === "number"
              ? value.toLocaleString("es-ES", {
                  minimumFractionDigits: 0,
                  maximumFractionDigits: 20,
                })
              : value === 0
                ? "0"
                : value !== undefined && value !== null
                  ? value
                  : "0"
          );
        },
      }));

      const periodoColumn = this.columns.find(col => col.prop === "periodo");
      if (periodoColumn) {
        periodoColumn.name = this.$t("simulacion.modulo.precios.hora");
      }

      const periodoIndex = this.columns.findIndex(col => col.prop === "periodo");
      if (periodoIndex !== -1) {
        const periodoCol = this.columns.splice(periodoIndex, 1)[0];
        this.columns.unshift(periodoCol);
      }
    } else {
      this.columns = [];
    }

},

handleCellEdit(event) {
  console.log("Intercepta...");

  const { detail } = event;
  let inputValue = detail.val;

  if (typeof inputValue === 'string') {
    inputValue = inputValue.replace(',', '.');
  }

  const newValue = Number(inputValue);
  const finalValue = isNaN(newValue) ? 0 : newValue;

  const rowIndex = detail.rowIndex;
  this.datos[rowIndex][detail.prop] = finalValue;

  const datosParaPadre = this.fusionarDatosEditadosConOriginal();

  this.$emit("update:modelValue", datosParaPadre);

  this.setColumns();

  console.log(`Fila actualizada (${rowIndex}):`, this.datos[rowIndex]);
},



    exportToCSV() {
      const headers = this.columns.map((col) => col.prop).join(";");
      const rows = this.datos.map((row) =>
        this.columns.map((col) => {
          const value = row[col.prop];
          if (typeof value === 'number') {
            return value.toLocaleString('es-ES', { minimumFractionDigits: 0, maximumFractionDigits: 20 });
          } else {
            return value !== undefined ? value : "";
          }
        }).join(";")
      );

      const csvContent = [headers, ...rows].join("\n");
      const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "precios.csv";
      a.click();
      URL.revokeObjectURL(url);
    },

    importFromCSV() {
      this.$refs.fileInput.click();
    },



    handleCSVUpload(event) {
      const file = event.target.files[0];
      if (file) {
        const reader = new FileReader();
        reader.onload = (e) => {
          const csvData = e.target.result;
          const [headerLine, ...lines] = csvData
            .split("\n")
            .map((line) => line.trim())
            .filter((line) => line.length > 0);
            const MAX_ROWS = 8784;
          if (lines.length > MAX_ROWS) {
            Swal.fire({
              icon: 'error',
              title: this.$t('mensajes.excel_demasiadas_filas_titulo') || 'Demasiadas filas',
              html:
                (this.$t('mensajes.excel_demasiadas_filas_texto') ||
                  'El fichero supera el máximo permitido.') +
                `<br><b>${lines.length.toLocaleString()}</b> filas detectadas. Máximo permitido: <b>${MAX_ROWS.toLocaleString()}</b>.`,
              confirmButtonText: 'OK',
            });
            event.target.value = ''; // resetea input
            return;
          }

          const headers = headerLine.split(";");

          const importedData = lines.map((line) => {
            const values = line.split(";");
            const obj = {};
            headers.forEach((header, index) => {
              const value = values[index];
              obj[header] = value === ""
                ? value
                : isNaN(Number(value.replace(",", ".")))
                  ? value
                  : Number(value.replace(",", "."));
            });
            return obj;
          });

          this.datos = this.normalizarDatosConHorizonte(importedData);
          this.$emit("update:modelValue", this.datos);
          this.setColumns();
        };
        reader.readAsText(file, "UTF-8");
      }
      event.target.value = ""; // Reset input
    },




  },

  mounted() {

    // Si los datos ya están disponibles cuando el componente se monta, los inicializamos
    if (this.datos.length > 0) {
      this.setColumns(); // Solo si ya hay datos
    }

  },


};
</script>

<style>
#app2 {
  height: 400px;
  width: 100%;
}
revo-grid {
  height: 100%;
  width: 100%;
  font-size: 12px;
}
</style>

